<template>
    <div>
        <DefaultMenu>
            <template #title>
                Canal de Denuncia
            </template>
     
            <b-button v-b-modal.createModalDenuncia>
                Denunciar <b-icon icon="megaphone" font-scale="1"></b-icon>
            </b-button>

            <b-button
                v-permission="'denuncias-menu-notificaciones'"
                class="ms-3"
                v-b-modal.notificacionesModalDenuncia>
                Notificaciones <b-icon icon="mailbox" font-scale="1"></b-icon>
            </b-button>

            <template #right>
                <b-button
                    v-permission="'denuncias-configuracion'"
                    @click="modalShowSetting = true"
                    title="Configuración"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="gear"/>
                </b-button>
            </template>
        </DefaultMenu>
        
        <BaseModal v-model="modalShowSetting" size="lg">
            <DenounceSetting></DenounceSetting>
        </BaseModal>

        <!-- Modal Denuncia -->
        <b-modal id="createModalDenuncia" title="Denunciar" size="lg" centered scrollable hide-footer
            header-bg-variant="dark" v-model="modalShowCrear">

            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>
            </template>

            <!-- cuerpo -->
            <AlertDismiss ref="alertDismiss" class="alert-sticky m-2"></AlertDismiss>
            <div class="card overflow-auto denounce-container">
                <div class="card-body">
                    <DenounceForm @alert="showAlert"></DenounceForm>
                </div>
            </div>

        </b-modal>

        <!-- Modal Notificaciones -->
        <b-modal id="notificacionesModalDenuncia" title="Notificaciones" size="xl" centered scrollable hide-footer
            header-bg-variant="dark" v-model="modalShowNotificar">

            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>
            </template>

            <DenounceNotification></DenounceNotification>

        </b-modal>
    </div>
</template>

<script>
import DenounceSetting from './DenounceMenu/Denounce-setting.vue'
import DefaultMenu from '@/components/shared/Default-menu.vue'
import DenounceForm from '@/components/Denounce/DenounceMenu/Denounce-form.vue';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import DenounceNotification from '@/components/Denounce/DenounceMenu/Denounce-notification.vue'
import { InitPageSize } from '@/plugins/enums/index.js'
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
    name: 'DenounceMenu',

    components: {
        DefaultMenu,
        DenounceForm,
        AlertDismiss,
        DenounceNotification,
        DenounceSetting,
        BaseModal
    },

    data() {
        return {
            modalShowCrear: false,
            modalShowNotificar: false,
            modalShowSetting: false,
            filter: {
                page: 1,
                pageSize: InitPageSize.DenouncePageSize
            },
        }
    },

    methods: {
        showAlert(message, type) {
            this.$refs.alertDismiss.showAlert(message, type);
        }
    }
}
</script>
<style scoped>

.alert-sticky {
    position: sticky;
    top: 0;
    z-index: 100;
}

</style>
